/** Plantillas rápidas para emails a clientes de pedidos / MercadoPago. */

export const ORDER_EMAIL_PLACEHOLDERS = [
  '{{nombre}}',
  '{{orderNumber}}',
  '{{total}}',
  '{{telefono}}',
  '{{email}}',
  '{{domicilio}}',
  '{{localidad}}',
  '{{provincia}}',
  '{{trackingNumber}}',
  '{{trackingLink}}'
];

export const BUILTIN_ORDER_EMAIL_TEMPLATES = [
  {
    id: 'builtin:preparacion',
    name: 'Pedido en preparación',
    subject: 'Tu pedido #{{orderNumber}} está en preparación — Priball',
    body: `Hola {{nombre}},

Recibimos tu pedido #{{orderNumber}} (total {{total}}) y ya lo estamos preparando.

En cuanto esté listo para envío o retiro te escribimos con los datos de seguimiento.

Gracias por elegir Priball.
El equipo de Priball`
  },
  {
    id: 'builtin:retiro',
    name: 'Listo para retiro',
    subject: 'Tu pedido #{{orderNumber}} está listo para retirar — Priball',
    body: `Hola {{nombre}},

Tu pedido #{{orderNumber}} ya está listo para retirar en nuestro local.

Dirección: Ruta 9 y Junín, Bell Ville, Córdoba.
Horario: de lunes a viernes, 8 a 17 hs.

Si necesitás coordinar otro horario, respondé este email o escribinos al WhatsApp.

¡Te esperamos!
El equipo de Priball`
  },
  {
    id: 'builtin:despachado',
    name: 'Pedido despachado',
    subject: 'Tu pedido #{{orderNumber}} ya está en camino — Priball',
    body: `Hola {{nombre}},

Tu pedido #{{orderNumber}} ya fue despachado.

Número de seguimiento: {{trackingNumber}}
Link de seguimiento: {{trackingLink}}

Cuando lo recibas, si hay cualquier detalle escribinos y lo resolvemos.

Gracias,
El equipo de Priball`
  },
  {
    id: 'builtin:datos-envio',
    name: 'Faltan datos de envío',
    subject: 'Necesitamos confirmar datos de envío — Pedido #{{orderNumber}}',
    body: `Hola {{nombre}},

Para despachar tu pedido #{{orderNumber}} necesitamos confirmar o completar los datos de entrega.

Datos actuales:
- Dirección: {{domicilio}}
- Localidad: {{localidad}}
- Provincia: {{provincia}}
- Teléfono: {{telefono}}

Respondé este email con la dirección completa, código postal y un teléfono de contacto.

Gracias,
El equipo de Priball`
  },
  {
    id: 'builtin:pago-pendiente',
    name: 'Pago pendiente (transferencia)',
    subject: 'Pendiente de pago — Pedido #{{orderNumber}}',
    body: `Hola {{nombre}},

Registramos tu pedido #{{orderNumber}} por {{total}}.

Para confirmarlo necesitamos el comprobante de transferencia. Cuando lo tengamos, preparamos el envío.

Si ya pagaste, reenviá el comprobante respondiendo este email.

Gracias,
El equipo de Priball`
  },
  {
    id: 'builtin:pago-acreditado',
    name: 'Pago acreditado',
    subject: 'Pago acreditado — Compra #{{orderNumber}}',
    body: `Hola {{nombre}},

Confirmamos que el pago de tu compra #{{orderNumber}} por {{total}} fue acreditado.

Estamos preparando el pedido. Te avisamos cuando salga hacia {{localidad}}.

Gracias por tu compra,
El equipo de Priball`
  },
  {
    id: 'builtin:demora',
    name: 'Demora / producción',
    subject: 'Actualización de tu pedido #{{orderNumber}} — Priball',
    body: `Hola {{nombre}},

Te escribimos por tu pedido #{{orderNumber}}.

Está en producción / personalización y puede demorar un poco más de lo habitual. Apenas esté listo te avisamos para coordinar el envío.

Gracias por tu paciencia,
El equipo de Priball`
  },
  {
    id: 'builtin:personalizado',
    name: 'Mensaje personalizado',
    subject: 'Novedades de tu pedido #{{orderNumber}} — Priball',
    body: `Hola {{nombre}},

`
  }
];

const formatPriceAr = (price) => {
  const n = Number(price);
  if (!Number.isFinite(n)) return '$0,00';
  return new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS'
  }).format(n);
};

export function buildOrderEmailVars(item = {}) {
  return {
    nombre: String(item.nombre || item.name || 'cliente').trim() || 'cliente',
    orderNumber: String(item.orderNumber || '').trim() || '—',
    total: formatPriceAr(item.totalPrice),
    telefono: String(item.telefono || '').trim() || '—',
    email: String(item.email || '').trim() || '—',
    domicilio: String(item.domicilio || '').trim() || '—',
    localidad: String(item.localidad || '').trim() || '—',
    provincia: String(item.provincia || '').trim() || '—',
    trackingNumber: String(item.trackingNumber || '').trim() || '(aún no cargado)',
    trackingLink: String(item.trackingLink || '').trim() || '(aún no cargado)'
  };
}

export function interpolateOrderEmail(text, item) {
  const vars = buildOrderEmailVars(item);
  return String(text || '').replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => {
    if (Object.prototype.hasOwnProperty.call(vars, key)) return vars[key];
    return `{{${key}}}`;
  });
}
